module.exports = __webpack_public_path__ + "img/elite.f605a1e1.svg";